import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';

import BackButton from '../../../components/custom/BackButton';
import ActionIcon from '../../../components/custom/ActionIcon';
import { OmitProps } from '../../../components/custom/hookForm/useTypedForm';
import { SupportTicket } from '../../../globals/interfaces';
import _ from 'lodash';

import { FormInputProps } from '../../../components/custom/hookForm/FormInput';

import { UseFormHandleSubmit } from 'react-hook-form';
import { CreateUpdateTicketWithParam } from './SupportRequestModal';
import { FormGroup } from 'reactstrap';
import { Label } from 'reactstrap';
import { ButtonGroup } from 'reactstrap';
import { Button } from 'reactstrap';

interface Props {
    modal: boolean;
    setModal: React.Dispatch<React.SetStateAction<boolean>>;
    closingNotes: string;
    resolved: boolean;
    setResolved: (value: boolean) => void;
    FormInput: React.FC<Omit<FormInputProps<SupportTicket>, OmitProps>>;
    createUpdateTicketWithParam: CreateUpdateTicketWithParam;
}

export default function CloseRequestModal ({
    modal,
    setModal,
    closingNotes,
    resolved,
    setResolved,
    createUpdateTicketWithParam,
    FormInput
}: Props) {

    const toggle = () => setModal(!modal);

    const resolvedOptions = [{
        label: 'Yes',
        color: 'primary',
        value: true
    }, {
        label: 'No',
        color: 'danger',
        value: false
    }];

    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>Close Ticket</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <FormGroup>
                    <Label className={'mr-2'}>Resolved</Label>
                    <ButtonGroup>
                        {
                            resolvedOptions.map((item, i) => (
                                <Button 
                                    color={item.color} 
                                    onClick={() => setResolved(item.value)}
                                    active={item.value === resolved}
                                    key={i}
                                >
                                    {item.label}
                                </Button>    
                            ))
                        }
                    </ButtonGroup>
                </FormGroup>
                <FormInput
                    label={'Closing Notes:'}
                    name={'closingNotes'}
                    type="textarea"
                />
            </ModalBody>
            <ExpandedFooter>
                <FooterContentContainer>
                    <FooterButtonsContainer>
                        {/* <ActionIcon
                            type={'save'}
                            onClick={createUpdateTicketWithParam({ status: 'CLOSED' })}
                            disabled={Boolean(!closingNotes || closingNotes.length < 10 || resolved === null)}
                        /> */}
                    </FooterButtonsContainer>
                </FooterContentContainer>
            </ExpandedFooter>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{ update?: boolean }>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
    gap: 25px;
`;
